module.exports = __webpack_public_path__ + "static/redyak-36f8ba1e294c64984d659e845e278cd0.jpg";